import type { Post } from '@/@types/post'
import { formatAsRelativeTime } from '@/utils/day'
import usePostNavigator from '@/utils/hooks/usePostNavigator'
import clsx from 'clsx'
import type { HTMLAttributes, MouseEvent } from 'react'
import Avatar from '../Avatar'
import ScreenName from '../ScreenName'
import ScreenNames from '../ScreenNames'
import PostHeader from './PostHeader'
import styles from './UserEndowPost.module.css'

export interface UserEndowPostProps extends HTMLAttributes<HTMLDivElement> {
	data: Post | undefined
}

export default function UserEndowPost({ data, className, ...props }: UserEndowPostProps) {
	const users = data?.users
	const user = users?.[0]
	const targetUser = data?.targetUser ?? data?.targetUsers?.[0]
	const endowTarget = data?.endowTarget
	const endowInfo = data?.endowInfo

	const navigateToPost = usePostNavigator()

	if (!data || !users || !user) {
		return null
	}

	const { createdAt } = data

	const handleTargetClick = (e: MouseEvent) => {
		e.stopPropagation()

		if (!endowTarget) {
			return
		}
		navigateToPost(
			{
				id: endowTarget.id,
				type: endowTarget.type,
				user: endowTarget.user,
			} as Post,
			e
		)
	}

	return (
		<div className={clsx(styles.container, className)} {...props}>
			<Avatar data={user} className={styles.avatar} />

			<div className={styles.content}>
				<PostHeader
					title={
						<div className={styles.title}>
							<ScreenNames data={users} />
							<span className={styles.secondaryText}>
								送出了礼物给
								{targetUser && (
									<>
										{' '}
										<ScreenName data={targetUser} />
									</>
								)}
							</span>
						</div>
					}
					desc={formatAsRelativeTime(createdAt)}
				/>
				{endowTarget && (
					<div className={styles.targetCard} onClick={handleTargetClick} data-clickable-feedback>
						{endowInfo?.picInfo && (
							<img
								src={endowInfo.picInfo.picUrl}
								alt={endowInfo.name}
								className={styles.endowPic}
							/>
						)}
						<div className={styles.targetTextWrapper}>
							<div className={styles.targetText}>{endowTarget.content}</div>
						</div>
					</div>
				)}
			</div>
		</div>
	)
}
